import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-qa": "payment-types-wrapper"
}
const _hoisted_2 = { class: "gfu-hd gfu-hd--h3 _mt-5" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($options.hasSelectablePaymentTypes)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString($options.headerText), 1 /* TEXT */),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.paymentTypes, (paymentType) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent(paymentType.name), _mergeProps({
            key: paymentType.name
          }, { ref_for: true }, paymentType.props, { onPaymentTypeChanged: $options.onPaymentTypeChanged }), null, 16 /* FULL_PROPS */, ["onPaymentTypeChanged"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    : _createCommentVNode("v-if", true)
}